import { render, staticRenderFns } from "./ModalObservacaoItemBemPermanente.vue?vue&type=template&id=5f8f1232&scoped=true"
import script from "./ModalObservacaoItemBemPermanente.vue?vue&type=script&lang=js"
export * from "./ModalObservacaoItemBemPermanente.vue?vue&type=script&lang=js"
import style0 from "./ModalObservacaoItemBemPermanente.vue?vue&type=style&index=0&id=5f8f1232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f1232",
  null
  
)

export default component.exports